import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { tariffSummaryGraphsQueries } from '../queries/tariffSummaryGraphsQueries';
import {
  getTariffSummarySubscriptionStatus,
  TARIFF_SUMMARY_SUBSCRIPTION_STATUS,
} from '../api/tariffSummaryGraphsApi';
import { getPieColors } from 'src/common/components/Graphs/common/Graphs/utils/doughnut';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

type UseTariffSummarySubscriptionStatusDataProps = {
  accountRef: string;
  tariffCode: string | null;
};
export const useTariffSummarySubscriptionStatusData = ({
  accountRef,
  tariffCode,
}: UseTariffSummarySubscriptionStatusDataProps) => {
  const { palette } = useTheme();
  const { t } = useTranslation();

  const { data } = useSuspenseQuery({
    queryKey: tariffSummaryGraphsQueries.subscriptionStatus({ accountRef, tariffCode }),
    queryFn: () =>
      setMinimalPromiseTime(getTariffSummarySubscriptionStatus({ accountRef, tariffCode })),
  });

  const subscriptionStatusData = useMemo(
    () => ({
      labels: [
        t('dashboard.subscriptionsStatusChart.legend.test'),
        t('dashboard.subscriptionsStatusChart.legend.active'),
        t('dashboard.subscriptionsStatusChart.legend.deactivated'),
      ],
      dataset: {
        data: [
          data.data[TARIFF_SUMMARY_SUBSCRIPTION_STATUS.TEST],
          data.data[TARIFF_SUMMARY_SUBSCRIPTION_STATUS.ACTIVE],
          data.data[TARIFF_SUMMARY_SUBSCRIPTION_STATUS.DEACTIVATED],
        ],
        ...getPieColors([palette.blue, palette.green, palette.red]),
      },
    }),
    [t, data],
  );

  return { chartData: subscriptionStatusData, total: data.total };
};
